import { request } from '@/utils/request';
import request2 from '@/utils/request2';
import APIURL from '@/api/apiUrl';
import APIURL2 from '@/api/apiUrl2';
// -------------------------------------------废弃开始
// 查询报警设置列表
export function getAlarmSetList(data) {
  return request.post(APIURL.alarmSet.list, data);
}

// 新增报警设置
export function addAlarmSet(data) {
  return request.post(APIURL.alarmSet.add, data);
}

// 修改报警设置
export function editAlarmSet(data) {
  return request.put(APIURL.alarmSet.update, data);
}

// 删除报警设置
export function delAlarmSet(params) {
  var data = {
    id: params
  };
  return request.delete(APIURL.dispatch.delete, data);
}

// 告警日志列表
export function alarmLogList(data) {
  return request2.post(APIURL2.log.alarm.list, data);
}
// ----------------------------------------------------废弃结束

// ----------------这几个不知道干什么？？？？？？
// 告警已阅 单条
export function alarmReadOne(id) {
  return request2.get(APIURL2.alarmRead.one, id);
}

// 告警已阅 多条/批量
export function alarmReadBatch() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return request2.post(APIURL2.alarmRead.batch, ids);
}

// 告警已阅全部数量
export function alarmReadClear() {
  return request2.get(APIURL2.alarmRead.clear);
}
// -------------------------------------

// -------派单------

// 新增派单接口
export function addDistributeLeaflets(data) {
  return request.post(APIURL.dispatch.add, data);
}

// 修改派单接口
export function updateDistributeLeaflets(data) {
  return request.put(APIURL.dispatch.update, data);
}

// 派单列表接口
export function myDispatchList(data) {
  return request.post(APIURL.dispatch.list, data);
}

// -------工单----------

// 生成工单接口
export function addOrder(data) {
  return request.post(APIURL.workOrder.add, data);
}

// 工单列表
export function orderList(data) {
  return request.post(APIURL.workOrder.list, data);
}

// 获取告警信息列表-list
export function getAlarmList(data) {
  return request.post(APIURL.alarm.list, data);
}

// 新增告警信息
export function addAlarm(data) {
  return request.post(APIURL.alarm.add, data);
}

// 新版告警日志列表-log
export function nAlarmLogList(data) {
  return request2.post(APIURL2.log.alarm.nList, data);
}

// 新版告警日志详情
export function nAlarmLogDtlList(data) {
  return request2.post(APIURL2.log.alarm.nDtlList, data);
}